import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListIntegrationServicePayload } from '@app-store/slices/integrationServices/list'

interface TaskAction extends Action {
    payload: IListIntegrationServicePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.integrationServices.list

function* listIntegrationServicesTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/integrations/services`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listIntegrationServices(): any {
    yield takeLatest<TaskAction>(onRequest, listIntegrationServicesTask)
}

export default listIntegrationServices
